import { Mqtt_Topics_practiceChanges } from "../ThreeDocs.Models/Api/Api.js";
import { singleton } from "../fable_modules/fable-library-js.4.25.0/List.js";
import { Msg } from "./PracticesTypes.js";

export function subscribe(uid) {
    return [singleton(Mqtt_Topics_practiceChanges(uid)), (Item) => (new Msg(4, [Item]))];
}

